// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"__404_wrapper__hCiMG","text":"__404_text__sptpE","big_numbers":"__404_big_numbers__i0cqw","img_man":"__404_img_man__dVdbE"};